import React from "react";
import "./TimeSlotSelector.css";

const TimeSlotSelector = ({
  selectedTimeslots,
  onTimeslotSelect,
  bookedTimeslots,
  selectedDate,
}) => {
  // Helper function to format the hour for display (e.g., "6AM")
  const formatHourDisplay = (hour, period) => {
    return `${hour}${period}`;
  };

  // Helper function to format the next hour for display (e.g., "7AM")
  const getNextHourDisplay = (hour, period) => {
    let nextHour = hour + 1;
    let nextPeriod = period;
    if (nextHour === 12) {
      nextPeriod = period === "AM" ? "PM" : "AM";
    }
    if (nextHour > 12) {
      nextHour = 1;
    }
    return formatHourDisplay(nextHour, nextPeriod);
  };

  // Generate time slots from 6 AM to 2 AM
  const generateTimeSlots = () => {
    const slots = [];
    let hour = 7;
    let period = "AM";

    const now = new Date();
    const currentDateTime = now.getTime(); // Current timestamp
    const currentDateNormalized = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    // console.log("Current Date and Time:", new Date(currentDateTime).toString());
    // console.log("Current Date Normalized:", currentDateNormalized.toString());

    for (let i = 0; i < 19; i++) {
      if (hour === 12) {
        period = period === "AM" ? "PM" : "AM";
      }
      if (hour > 12) {
        hour = 1;
      }

      const formattedHour = hour.toString().padStart(2, "0");
      const time = `${formattedHour}:00 ${period}`; // Original format (e.g., "06:00 AM")
      const startDisplay = formatHourDisplay(hour, period); // e.g., "6AM"
      const endDisplay = getNextHourDisplay(hour, period); // e.g., "7AM"
      let displayTime = `${startDisplay} - ${endDisplay}`; // Display format (e.g., "6AM - 7AM")

      // Append "(Next Day)" as a subscript for 12:00 AM and 1:00 AM slots
      if (time === "12:00 AM" || time === "01:00 AM" || time === "02:00 AM" || time === "03:00 AM" || time === "04:00 AM" || time === "05:00 AM" || time === "06:00 AM") {
        displayTime += `<sub style="font-size: 0.7em;">(Next Day)</sub>`;
      }

      let slotHour = hour;
      if (period === "PM" && hour !== 12) slotHour += 12;
      if (period === "AM" && hour === 12) slotHour = 0;

      const slotDate = new Date(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate()
      );
      if (period === "AM" && (hour === 12 || (hour >= 1 && hour <= 6))) {
        slotDate.setDate(slotDate.getDate() + 1);
      }

      const slotDateTime = new Date(
        slotDate.getFullYear(),
        slotDate.getMonth(),
        slotDate.getDate(),
        slotHour,
        0
      ).getTime();
      // console.log(`Slot ${time} - Slot DateTime:`, new Date(slotDateTime).toString());

      // Set slotEndTime to the end of the hour
      const slotEndDate = new Date(slotDate); // Copy the adjusted date
      const slotEndTime = new Date(slotEndDate.setHours(slotHour + 1, 0, 0, 0)).getTime();
      // console.log(`Slot ${time} - Slot EndTime:`, new Date(slotEndTime).toString());

      // Normalize slotDate for comparison
      const slotDateNormalized = new Date(slotDate.getFullYear(), slotDate.getMonth(), slotDate.getDate());
      // console.log(`Slot ${time} - Slot Date Normalized:`, slotDateNormalized.toString());

      let status;
      const isPast =
        slotDateNormalized < currentDateNormalized ||
        (slotDateNormalized.getTime() === currentDateNormalized.getTime() &&
          slotEndTime <= currentDateTime);
      // console.log(
      //   `Slot ${time} - Past Check: slotDateNormalized=${slotDateNormalized.toString()}, currentDateNormalized=${currentDateNormalized.toString()}, slotEndTime=${new Date(
      //     slotEndTime
      //   ).toString()}, currentDateTime=${new Date(currentDateTime).toString()}, isPast=${isPast}`
      // );
      if (bookedTimeslots.includes(time)) {
        status = "booked";
      } else if (isPast) {
        status = "past";
      } else {
        status = "available";
      }

      slots.push({
        time: time,
        displayTime: displayTime,
        id: i,
        status: status,
      });
      hour++;
    }

    return slots;
  };

  const toggleSlot = (time) => {
    const slot = generateTimeSlots().find((slot) => slot.time === time);
    if (slot?.status === "booked" || slot?.status === "past") return;
    onTimeslotSelect(time);
  };

  const slots = generateTimeSlots();

  return (
    <div className="time-slot-container">
      <table className="time-slot-table">
        <tbody>
          {slots.map((slot) => (
            <tr key={slot.id}>
              <td
                className="time-label"
                dangerouslySetInnerHTML={{ __html: slot.displayTime }}
              />
              <td className="slot-box-container">
                <div
                  className={`slot-box ${slot.status} ${
                    selectedTimeslots.includes(slot.time) ? "selected" : ""
                  }`}
                  onClick={() => toggleSlot(slot.time)}
                >
                  <div className="slot-box-front"></div>
                  <div className="slot-box-back"></div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TimeSlotSelector;